exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".im-iframe-container{position:fixed;top:0;right:0;bottom:0;left:0;z-index:10}.im-iframe-container iframe{width:100%;height:100%}", ""]);

// exports
